import qs from 'qs';
import { network } from 'services/network';

export const deleteStoredFilterBulkAssignToUser = ({ id, contractId }) => {
    const querystring = qs.stringify({ id, contractId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/deleteStoredFilterBulkAssignToUser${querystring}`;

    return network.get(url).then((response) => response.data);
};
